/**
 * Bazaarvoice inline rating — wrapper spacing only.
 * BV DOM overrides live in `theme/contentful/bazaarvoice-pdp-global.js`.
 */

const BazaarvoiceInlineRating = {
  parts: ['container'],
  baseStyle: {
    container: {
      display: 'block',
      width: 'fit-content',
    },
  },
  variants: {
    default: {
      container: {
        minH: '1.5rem',
        mt: 2,
      },
    },
    tile: {
      container: {
        minH: '1.25rem',
        mt: 0,
      },
    },
    strip: {
      container: {
        flexShrink: 0,
        minH: '1rem',
        mt: 0,
      },
    },
  },
  defaultProps: {
    variant: 'default',
  },
};

export default BazaarvoiceInlineRating;
